import { render, staticRenderFns } from "./CInvoiceDetails.vue?vue&type=template&id=7ae2bbe1&scoped=true"
import script from "./CInvoiceDetails.vue?vue&type=script&lang=ts"
export * from "./CInvoiceDetails.vue?vue&type=script&lang=ts"
import style0 from "./CInvoiceDetails.vue?vue&type=style&index=0&id=7ae2bbe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2bbe1",
  null
  
)

export default component.exports